import { render, staticRenderFns } from "./ProductPreviewComponent.vue?vue&type=template&id=5eaf6e54&scoped=true"
import script from "./ProductPreviewComponent.vue?vue&type=script&lang=js"
export * from "./ProductPreviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductPreviewComponent.vue?vue&type=style&index=0&id=5eaf6e54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaf6e54",
  null
  
)

export default component.exports